import React from 'react';

import * as styles from './styles';

interface TooltipProps {
  title: string;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  children,
}) => {
  return (
    <styles.Container className={className}>
      {children}
      <span>{title}</span>
    </styles.Container>
  );
};

export default Tooltip;
